<app-dry-run-warning></app-dry-run-warning>
<div class="content grid-3">
  <app-sync [entity]="'Candidate'"></app-sync>
  <app-sync [entity]="'ClientContact'"></app-sync>
  <app-sync [entity]="'ClientCorporation'"></app-sync>
</div>
